// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_24-6";
export var headerCell = "_24-2";
export var rowWrapper = "_24-4";
export var stickyAggregationCell = "_24-a";
export var stickyAggregationRow = "_24-7";
export var stickyColumnCell = "_24-9";
export var stickyColumnHeaderCell = "_24-8";
export var table = "_24-1";
export var virtualRowWrapper = "_24-5";
export var virtualTableContainer = "_24-0";
export var white = "_24-3";